import { FlowNodeType } from '../../../types/flowBuilder';

export interface NodeColorScheme {
  gradient: {
    from: string;
    to: string;
  };
  border: {
    default: string;
    selected: string;
  };
  text: {
    primary: string;
    secondary: string;
  };
  handle: string;
}

// Központi színdefiníciók minden node típushoz
export const NODE_COLORS: Record<FlowNodeType, NodeColorScheme> = {
  // Trigger típusok
  trigger: {
    gradient: { from: 'from-yellow-400', to: 'to-yellow-500' },
    border: { default: 'border-yellow-300', selected: 'border-yellow-600' },
    text: { primary: 'text-white', secondary: 'text-yellow-100' },
    handle: 'border-yellow-500'
  },
  webhook_trigger: {
    gradient: { from: 'from-yellow-400', to: 'to-yellow-500' },
    border: { default: 'border-yellow-300', selected: 'border-yellow-600' },
    text: { primary: 'text-white', secondary: 'text-yellow-100' },
    handle: 'border-yellow-500'
  },
  schedule_trigger: {
    gradient: { from: 'from-orange-400', to: 'to-orange-500' },
    border: { default: 'border-orange-300', selected: 'border-orange-600' },
    text: { primary: 'text-white', secondary: 'text-orange-100' },
    handle: 'border-orange-500'
  },
  form_trigger: {
    gradient: { from: 'from-green-400', to: 'to-green-500' },
    border: { default: 'border-green-300', selected: 'border-green-600' },
    text: { primary: 'text-white', secondary: 'text-green-100' },
    handle: 'border-green-500'
  },
  email_trigger: {
    gradient: { from: 'from-blue-400', to: 'to-blue-500' },
    border: { default: 'border-blue-300', selected: 'border-blue-600' },
    text: { primary: 'text-white', secondary: 'text-blue-100' },
    handle: 'border-blue-500'
  },
  file_trigger: {
    gradient: { from: 'from-purple-400', to: 'to-purple-500' },
    border: { default: 'border-purple-300', selected: 'border-purple-600' },
    text: { primary: 'text-white', secondary: 'text-purple-100' },
    handle: 'border-purple-500'
  },
  telegram_trigger: {
    gradient: { from: 'from-blue-400', to: 'to-blue-500' },
    border: { default: 'border-blue-300', selected: 'border-blue-600' },
    text: { primary: 'text-white', secondary: 'text-blue-100' },
    handle: 'border-blue-500'
  },
  database_trigger: {
    gradient: { from: 'from-indigo-400', to: 'to-indigo-500' },
    border: { default: 'border-indigo-300', selected: 'border-indigo-600' },
    text: { primary: 'text-white', secondary: 'text-indigo-100' },
    handle: 'border-indigo-500'
  },
  manual_trigger: {
    gradient: { from: 'from-gray-400', to: 'to-gray-500' },
    border: { default: 'border-gray-300', selected: 'border-gray-600' },
    text: { primary: 'text-white', secondary: 'text-gray-100' },
    handle: 'border-gray-500'
  },
  
  // Action típusok
  action: {
    gradient: { from: 'from-blue-400', to: 'to-blue-500' },
    border: { default: 'border-blue-300', selected: 'border-blue-600' },
    text: { primary: 'text-white', secondary: 'text-blue-100' },
    handle: 'border-blue-500'
  },
  condition: {
    gradient: { from: 'from-purple-400', to: 'to-purple-500' },
    border: { default: 'border-purple-300', selected: 'border-purple-600' },
    text: { primary: 'text-white', secondary: 'text-purple-100' },
    handle: 'border-purple-500'
  },
  switch: {
    gradient: { from: 'from-indigo-400', to: 'to-indigo-500' },
    border: { default: 'border-indigo-300', selected: 'border-indigo-600' },
    text: { primary: 'text-white', secondary: 'text-indigo-100' },
    handle: 'border-indigo-500'
  },
  merge: {
    gradient: { from: 'from-teal-400', to: 'to-teal-500' },
    border: { default: 'border-teal-300', selected: 'border-teal-600' },
    text: { primary: 'text-white', secondary: 'text-teal-100' },
    handle: 'border-teal-500'
  },
  wait: {
    gradient: { from: 'from-emerald-400', to: 'to-emerald-500' },
    border: { default: 'border-emerald-300', selected: 'border-emerald-600' },
    text: { primary: 'text-white', secondary: 'text-emerald-100' },
    handle: 'border-emerald-500'
  },
  loop: {
    gradient: { from: 'from-amber-400', to: 'to-amber-500' },
    border: { default: 'border-amber-300', selected: 'border-amber-600' },
    text: { primary: 'text-white', secondary: 'text-amber-100' },
    handle: 'border-amber-500'
  },
  form: {
    gradient: { from: 'from-orange-400', to: 'to-orange-500' },
    border: { default: 'border-orange-300', selected: 'border-orange-600' },
    text: { primary: 'text-white', secondary: 'text-orange-100' },
    handle: 'border-orange-500'
  },
  approval: {
    gradient: { from: 'from-emerald-500', to: 'to-emerald-600' },
    border: { default: 'border-emerald-400', selected: 'border-emerald-700' },
    text: { primary: 'text-white', secondary: 'text-emerald-100' },
    handle: 'border-emerald-600'
  },
  notification: {
    gradient: { from: 'from-red-400', to: 'to-red-500' },
    border: { default: 'border-red-300', selected: 'border-red-600' },
    text: { primary: 'text-white', secondary: 'text-red-100' },
    handle: 'border-red-500'
  },
  smtp_email: {
    gradient: { from: 'from-orange-400', to: 'to-orange-500' },
    border: { default: 'border-orange-300', selected: 'border-orange-600' },
    text: { primary: 'text-white', secondary: 'text-orange-100' },
    handle: 'border-orange-500'
  },
  telegram_message: {
    gradient: { from: 'from-blue-400', to: 'to-blue-500' },
    border: { default: 'border-blue-300', selected: 'border-blue-600' },
    text: { primary: 'text-white', secondary: 'text-blue-100' },
    handle: 'border-blue-500'
  },
  sms_send: {
    gradient: { from: 'from-green-400', to: 'to-green-500' },
    border: { default: 'border-green-300', selected: 'border-green-600' },
    text: { primary: 'text-white', secondary: 'text-green-100' },
    handle: 'border-green-500'
  },
  flintsign_sign: {
    gradient: { from: 'from-emerald-400', to: 'to-emerald-500' },
    border: { default: 'border-emerald-300', selected: 'border-emerald-600' },
    text: { primary: 'text-white', secondary: 'text-emerald-100' },
    handle: 'border-emerald-500'
  },
  data_transform: {
    gradient: { from: 'from-gray-400', to: 'to-gray-500' },
    border: { default: 'border-gray-300', selected: 'border-gray-600' },
    text: { primary: 'text-white', secondary: 'text-gray-100' },
    handle: 'border-gray-500'
  },
  integration: {
    gradient: { from: 'from-gray-400', to: 'to-gray-500' },
    border: { default: 'border-gray-300', selected: 'border-gray-600' },
    text: { primary: 'text-white', secondary: 'text-gray-100' },
    handle: 'border-gray-500'
  },
  crm_action: {
    gradient: { from: 'from-cyan-400', to: 'to-cyan-500' },
    border: { default: 'border-cyan-300', selected: 'border-cyan-600' },
    text: { primary: 'text-white', secondary: 'text-cyan-100' },
    handle: 'border-cyan-500'
  },
  
  // Új node típusok
  debug_logger: {
    gradient: { from: 'from-emerald-400', to: 'to-emerald-500' },
    border: { default: 'border-emerald-300', selected: 'border-emerald-600' },
    text: { primary: 'text-white', secondary: 'text-emerald-100' },
    handle: 'border-emerald-500'
  },
  variable_set: {
    gradient: { from: 'from-emerald-400', to: 'to-emerald-500' },
    border: { default: 'border-emerald-300', selected: 'border-emerald-600' },
    text: { primary: 'text-white', secondary: 'text-emerald-100' },
    handle: 'border-emerald-500'
  },
  variable_get: {
    gradient: { from: 'from-emerald-500', to: 'to-emerald-600' },
    border: { default: 'border-emerald-400', selected: 'border-emerald-700' },
    text: { primary: 'text-white', secondary: 'text-emerald-100' },
    handle: 'border-emerald-600'
  },
  text_processor: {
    gradient: { from: 'from-amber-400', to: 'to-amber-500' },
    border: { default: 'border-amber-300', selected: 'border-amber-600' },
    text: { primary: 'text-white', secondary: 'text-amber-100' },
    handle: 'border-amber-500'
  },
  math_operation: {
    gradient: { from: 'from-orange-400', to: 'to-orange-500' },
    border: { default: 'border-orange-300', selected: 'border-orange-600' },
    text: { primary: 'text-white', secondary: 'text-orange-100' },
    handle: 'border-orange-500'
  },
  date_time: {
    gradient: { from: 'from-sky-400', to: 'to-sky-500' },
    border: { default: 'border-sky-300', selected: 'border-sky-600' },
    text: { primary: 'text-white', secondary: 'text-sky-100' },
    handle: 'border-sky-500'
  },
  random_generator: {
    gradient: { from: 'from-pink-400', to: 'to-pink-500' },
    border: { default: 'border-pink-300', selected: 'border-pink-600' },
    text: { primary: 'text-white', secondary: 'text-pink-100' },
    handle: 'border-pink-500'
  },
  counter: {
    gradient: { from: 'from-teal-400', to: 'to-teal-500' },
    border: { default: 'border-teal-300', selected: 'border-teal-600' },
    text: { primary: 'text-white', secondary: 'text-teal-100' },
    handle: 'border-teal-500'
  },
  multi_condition: {
    gradient: { from: 'from-purple-400', to: 'to-purple-500' },
    border: { default: 'border-purple-300', selected: 'border-purple-600' },
    text: { primary: 'text-white', secondary: 'text-purple-100' },
    handle: 'border-purple-500'
  },
  data_filter: {
    gradient: { from: 'from-indigo-400', to: 'to-indigo-500' },
    border: { default: 'border-indigo-300', selected: 'border-indigo-600' },
    text: { primary: 'text-white', secondary: 'text-indigo-100' },
    handle: 'border-indigo-500'
  },
  data_sort: {
    gradient: { from: 'from-indigo-500', to: 'to-indigo-600' },
    border: { default: 'border-indigo-400', selected: 'border-indigo-700' },
    text: { primary: 'text-white', secondary: 'text-indigo-100' },
    handle: 'border-indigo-600'
  },
  json_processor: {
    gradient: { from: 'from-slate-400', to: 'to-slate-500' },
    border: { default: 'border-slate-300', selected: 'border-slate-600' },
    text: { primary: 'text-white', secondary: 'text-slate-100' },
    handle: 'border-slate-500'
  },
  string_formatter: {
    gradient: { from: 'from-amber-400', to: 'to-amber-500' },
    border: { default: 'border-amber-300', selected: 'border-amber-600' },
    text: { primary: 'text-white', secondary: 'text-amber-100' },
    handle: 'border-amber-500'
  },
  list_processor: {
    gradient: { from: 'from-purple-400', to: 'to-purple-500' },
    border: { default: 'border-purple-300', selected: 'border-purple-600' },
    text: { primary: 'text-white', secondary: 'text-purple-100' },
    handle: 'border-purple-500'
  },
  // AI Integration színek
  openai_chat: {
    gradient: { from: 'from-green-400', to: 'to-green-500' },
    border: { default: 'border-green-300', selected: 'border-green-600' },
    text: { primary: 'text-white', secondary: 'text-green-100' },
    handle: 'border-green-500'
  },
  claude_chat: {
    gradient: { from: 'from-orange-400', to: 'to-orange-500' },
    border: { default: 'border-orange-300', selected: 'border-orange-600' },
    text: { primary: 'text-white', secondary: 'text-orange-100' },
    handle: 'border-orange-500'
  },
  deepseek_chat: {
    gradient: { from: 'from-blue-400', to: 'to-blue-500' },
    border: { default: 'border-blue-300', selected: 'border-blue-600' },
    text: { primary: 'text-white', secondary: 'text-blue-100' },
    handle: 'border-blue-500'
  },
  gemini_chat: {
    gradient: { from: 'from-purple-400', to: 'to-purple-500' },
    border: { default: 'border-purple-300', selected: 'border-purple-600' },
    text: { primary: 'text-white', secondary: 'text-purple-100' },
    handle: 'border-purple-500'
  },
  ai_text_generator: {
    gradient: { from: 'from-indigo-400', to: 'to-indigo-500' },
    border: { default: 'border-indigo-300', selected: 'border-indigo-600' },
    text: { primary: 'text-white', secondary: 'text-indigo-100' },
    handle: 'border-indigo-500'
  },
  ai_image_generator: {
    gradient: { from: 'from-pink-400', to: 'to-pink-500' },
    border: { default: 'border-pink-300', selected: 'border-pink-600' },
    text: { primary: 'text-white', secondary: 'text-pink-100' },
    handle: 'border-pink-500'
  },
  ai_text_analyzer: {
    gradient: { from: 'from-cyan-400', to: 'to-cyan-500' },
    border: { default: 'border-cyan-300', selected: 'border-cyan-600' },
    text: { primary: 'text-white', secondary: 'text-cyan-100' },
    handle: 'border-cyan-500'
  },
  ai_translator: {
    gradient: { from: 'from-emerald-400', to: 'to-emerald-500' },
    border: { default: 'border-emerald-300', selected: 'border-emerald-600' },
    text: { primary: 'text-white', secondary: 'text-emerald-100' },
    handle: 'border-emerald-500'
  },
  ai_summarizer: {
    gradient: { from: 'from-amber-400', to: 'to-amber-500' },
    border: { default: 'border-amber-300', selected: 'border-amber-600' },
    text: { primary: 'text-white', secondary: 'text-amber-100' },
    handle: 'border-amber-500'
  },
  // Fájl műveletek
  file_read: {
    gradient: { from: 'from-rose-400', to: 'to-rose-500' },
    border: { default: 'border-rose-300', selected: 'border-rose-600' },
    text: { primary: 'text-white', secondary: 'text-rose-100' },
    handle: 'border-rose-500'
  },
  file_write: {
    gradient: { from: 'from-rose-500', to: 'to-rose-600' },
    border: { default: 'border-rose-400', selected: 'border-rose-700' },
    text: { primary: 'text-white', secondary: 'text-rose-100' },
    handle: 'border-rose-600'
  },
  pdf_generator: {
    gradient: { from: 'from-red-500', to: 'to-red-600' },
    border: { default: 'border-red-400', selected: 'border-red-700' },
    text: { primary: 'text-white', secondary: 'text-red-100' },
    handle: 'border-red-600'
  },
  excel_processor: {
    gradient: { from: 'from-green-500', to: 'to-green-600' },
    border: { default: 'border-green-400', selected: 'border-green-700' },
    text: { primary: 'text-white', secondary: 'text-green-100' },
    handle: 'border-green-600'
  },
  image_processor: {
    gradient: { from: 'from-purple-400', to: 'to-purple-500' },
    border: { default: 'border-purple-300', selected: 'border-purple-600' },
    text: { primary: 'text-white', secondary: 'text-purple-100' },
    handle: 'border-purple-500'
  },
  file_converter: {
    gradient: { from: 'from-pink-400', to: 'to-pink-500' },
    border: { default: 'border-pink-300', selected: 'border-pink-600' },
    text: { primary: 'text-white', secondary: 'text-pink-100' },
    handle: 'border-pink-500'
  },
  // Data Parsers
  csv_parser: {
    gradient: { from: 'from-teal-400', to: 'to-teal-500' },
    border: { default: 'border-teal-300', selected: 'border-teal-600' },
    text: { primary: 'text-white', secondary: 'text-teal-100' },
    handle: 'border-teal-500'
  },
  xml_parser: {
    gradient: { from: 'from-orange-400', to: 'to-orange-500' },
    border: { default: 'border-orange-300', selected: 'border-orange-600' },
    text: { primary: 'text-white', secondary: 'text-orange-100' },
    handle: 'border-orange-500'
  },
  yaml_parser: {
    gradient: { from: 'from-cyan-400', to: 'to-cyan-500' },
    border: { default: 'border-cyan-300', selected: 'border-cyan-600' },
    text: { primary: 'text-white', secondary: 'text-cyan-100' },
    handle: 'border-cyan-500'
  },
  base64_coder: {
    gradient: { from: 'from-lime-400', to: 'to-lime-500' },
    border: { default: 'border-lime-300', selected: 'border-lime-600' },
    text: { primary: 'text-white', secondary: 'text-lime-100' },
    handle: 'border-lime-500'
  },
  data_validator: {
    gradient: { from: 'from-emerald-400', to: 'to-emerald-500' },
    border: { default: 'border-emerald-300', selected: 'border-emerald-600' },
    text: { primary: 'text-white', secondary: 'text-emerald-100' },
    handle: 'border-emerald-500'
  },
  // Database műveletek
  database_query: {
    gradient: { from: 'from-indigo-400', to: 'to-indigo-500' },
    border: { default: 'border-indigo-300', selected: 'border-indigo-600' },
    text: { primary: 'text-white', secondary: 'text-indigo-100' },
    handle: 'border-indigo-500'
  },
  database_insert: {
    gradient: { from: 'from-indigo-500', to: 'to-indigo-600' },
    border: { default: 'border-indigo-400', selected: 'border-indigo-700' },
    text: { primary: 'text-white', secondary: 'text-indigo-100' },
    handle: 'border-indigo-600'
  },
  database_update: {
    gradient: { from: 'from-indigo-500', to: 'to-indigo-600' },
    border: { default: 'border-indigo-400', selected: 'border-indigo-700' },
    text: { primary: 'text-white', secondary: 'text-indigo-100' },
    handle: 'border-indigo-600'
  },
  database_delete: {
    gradient: { from: 'from-indigo-600', to: 'to-indigo-700' },
    border: { default: 'border-indigo-500', selected: 'border-indigo-800' },
    text: { primary: 'text-white', secondary: 'text-indigo-100' },
    handle: 'border-indigo-700'
  },
  // Error Handling
  try_catch: {
    gradient: { from: 'from-amber-400', to: 'to-amber-500' },
    border: { default: 'border-amber-300', selected: 'border-amber-600' },
    text: { primary: 'text-white', secondary: 'text-amber-100' },
    handle: 'border-amber-500'
  },
  retry: {
    gradient: { from: 'from-blue-400', to: 'to-blue-500' },
    border: { default: 'border-blue-300', selected: 'border-blue-600' },
    text: { primary: 'text-white', secondary: 'text-blue-100' },
    handle: 'border-blue-500'
  },
  error_logger: {
    gradient: { from: 'from-red-400', to: 'to-red-500' },
    border: { default: 'border-red-300', selected: 'border-red-600' },
    text: { primary: 'text-white', secondary: 'text-red-100' },
    handle: 'border-red-500'
  },
  timeout: {
    gradient: { from: 'from-orange-400', to: 'to-orange-500' },
    border: { default: 'border-orange-300', selected: 'border-orange-600' },
    text: { primary: 'text-white', secondary: 'text-orange-100' },
    handle: 'border-orange-500'
  }
};

// Helper funkció a színek lekérdezéséhez
export function getNodeColors(nodeType: FlowNodeType): NodeColorScheme {
  return NODE_COLORS[nodeType] || NODE_COLORS.action;
}

// Helper funkció hex színkódok lekérdezéséhez (FlowCanvas kompatibilitás)
export function getNodeHexColor(nodeType: FlowNodeType): string {
  const colorMap: Record<FlowNodeType, string> = {
    // Trigger típusok
    trigger: '#eab308', // yellow-500
    webhook_trigger: '#eab308', // yellow-500
    schedule_trigger: '#f97316', // orange-500
    form_trigger: '#22c55e', // green-500
    email_trigger: '#3b82f6', // blue-500
    file_trigger: '#8b5cf6', // violet-500
    telegram_trigger: '#3b82f6', // blue-500
    database_trigger: '#6366f1', // indigo-500
    manual_trigger: '#6b7280', // gray-500
    // Action típusok
    action: '#3b82f6', // blue-500
    condition: '#8b5cf6', // violet-500
    switch: '#6366f1', // indigo-500
    merge: '#14b8a6', // teal-500
    wait: '#10b981', // emerald-500
    loop: '#f59e0b', // amber-500
    form: '#f97316', // orange-500
    approval: '#059669', // emerald-600
    notification: '#ef4444', // red-500
    smtp_email: '#f97316', // orange-500
    telegram_message: '#3b82f6', // blue-500
    sms_send: '#22c55e', // green-500
    flintsign_sign: '#10b981', // emerald-500
    data_transform: '#6b7280', // gray-500
    integration: '#6b7280', // gray-500
    crm_action: '#06b6d4', // cyan-500
    // Új node típusok
    debug_logger: '#10b981', // emerald-500
    variable_set: '#10b981', // emerald-500
    variable_get: '#059669', // emerald-600
    text_processor: '#f59e0b', // amber-500
    math_operation: '#f97316', // orange-500
    date_time: '#0ea5e9', // sky-500
    random_generator: '#ec4899', // pink-500
    counter: '#14b8a6', // teal-500
    multi_condition: '#8b5cf6', // violet-500
    data_filter: '#6366f1', // indigo-500
    data_sort: '#4f46e5', // indigo-600
    json_processor: '#64748b', // slate-500
    string_formatter: '#f59e0b', // amber-500
    list_processor: '#8b5cf6', // violet-500
    // Fájl műveletek hex színek
    file_read: '#f43f5e', // rose-500
    file_write: '#e11d48', // rose-600
    pdf_generator: '#dc2626', // red-600
    excel_processor: '#16a34a', // green-600
    image_processor: '#a855f7', // purple-500
    file_converter: '#ec4899', // pink-500
    // Data Parsers hex színek
    csv_parser: '#14b8a6', // teal-500
    xml_parser: '#f97316', // orange-500
    yaml_parser: '#06b6d4', // cyan-500
    base64_coder: '#84cc16', // lime-500
    data_validator: '#10b981', // emerald-500
    // Database műveletek hex színek
    database_query: '#6366f1', // indigo-500
    database_insert: '#4f46e5', // indigo-600
    database_update: '#4f46e5', // indigo-600
    database_delete: '#4338ca', // indigo-700
    // Error Handling hex színek
    try_catch: '#f59e0b', // amber-500
    retry: '#3b82f6', // blue-500
    error_logger: '#ef4444', // red-500
    timeout: '#f97316', // orange-500
    // AI Integration hex színek
    openai_chat: '#22c55e', // green-500
    claude_chat: '#f97316', // orange-500
    deepseek_chat: '#3b82f6', // blue-500
    gemini_chat: '#8b5cf6', // violet-500
    ai_text_generator: '#6366f1', // indigo-500
    ai_image_generator: '#ec4899', // pink-500
    ai_text_analyzer: '#06b6d4', // cyan-500
    ai_translator: '#10b981', // emerald-500
    ai_summarizer: '#f59e0b', // amber-500
  };
  
  return colorMap[nodeType] || '#6b7280';
}
